import React from 'react';
import video from './assets/movestitucional.mp4';
import logo from './assets/logoEmpe.jpg';

export default function PinnacleLanding() {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="bg-black text-white min-h-screen" style={{ fontFamily: 'Montserrat, sans-serif' }}>
      
      {/* Seção 1: Hero com Vídeo */}
      <section className="relative w-full h-screen overflow-hidden flex items-center justify-center">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        >
          <source src= {video}  type="video/mp4" />
        </video>
        
        <div className="relative z-10 text-center px-6">
          <img
            src={logo}
            alt="The Pinnacle"
            className="mx-auto mb-8 w-48 md:w-64"
          />
          
          <h1 className="text-5xl md:text-7xl mb-6 font-light tracking-wider" style={{ fontFamily: 'serif', color: '#D4AF37' }}>
            THE PINNACLE<br/>FLATS E STUDIOS
          </h1>
          
          <p className="text-2xl md:text-3xl mb-4 italic" style={{ color: '#D4AF37' }}>
            O ápice do viver bem.
          </p>
          
          <p className="text-lg md:text-xl text-gray-300 mb-8">
            Desde 2012
          </p>
          
          <button 
            onClick={() => scrollToSection('conceito')}
            className="text-white border-2 hover:bg-white hover:text-black transition-all duration-300 font-semibold text-lg px-10 py-3 cursor-pointer"
            style={{ borderColor: '#D4AF37' }}
          >
            Conheça mais
          </button>
        </div>
      </section>

      {/* Seção 2: Introdução e Conceito */}
      <section id="conceito" className="bg-black text-white py-24 px-6 md:px-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <img src="/logoEmpe.png" alt="Logo" className="mx-auto w-24 mb-8 opacity-80" />
          </div>
          
          <h2 className="text-3xl md:text-4xl text-center mb-12" style={{ fontFamily: 'serif', color: '#D4AF37' }}>
            Introdução e Conceito
          </h2>
          
          <div className="mb-12">
            <h3 className="text-2xl mb-6" style={{ color: '#D4AF37' }}>A Essência Pinnacle</h3>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p>
                <strong>• Visão:</strong> Ser a rede de referência nacional em hospedagem de curta e longa duração,
                redefinindo o conceito de moradia e estadia com inteligência e elegância.
              </p>
              <p>
                <strong>• Missão:</strong> Oferecer soluções de hospedagem flexíveis que unem o conforto de um lar, a
                eficiência de um escritório e o serviço de um hotel de alto padrão.
              </p>
              <p>
                <strong>• Conceito Central:</strong> "O Luxo da Flexibilidade." The Pinnacle Flats e Studios atende ao
                profissional moderno e ao viajante exigente, oferecendo espaços que se adaptam
                dinamicamente às suas necessidades.
              </p>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl mb-6" style={{ color: '#D4AF37' }}>Nossa História (Desde 2012)</h3>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p>
                • Fundada em 2012, a The Pinnacle Flats e Studios nasceu com o propósito de preencher a
                lacuna entre o tradicional hotel e o aluguel residencial.
              </p>
              <p>
                • Ao longo de mais de uma década, consolidamos uma rede nacional baseada em design
                arquitetônico clean, localização estratégica e um serviço premium ininterrupto.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Seção 3: Tipologias */}
      <section className="bg-zinc-900 text-white py-24 px-6 md:px-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <img src="/logoEmpe.png" alt="Logo" className="mx-auto w-24 mb-8 opacity-80" />
          </div>
          
          <h2 className="text-3xl md:text-4xl text-center mb-12" style={{ fontFamily: 'serif', color: '#D4AF37' }}>
            Variações e Tipologias de Espaço
          </h2>
          
          <div className="mb-16">
            <h3 className="text-2xl mb-8" style={{ color: '#D4AF37' }}>Tipologias Principais</h3>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p>
                <strong>• Flats:</strong> Unidades maiores, idealmente com quarto e sala separados, projetadas para estadias
                de média e longa duração. Foco em conforto residencial elevado e áreas de convívio bem
                definidas.
              </p>
              <p>
                <strong>• Studios:</strong> Espaços open concept inteligentes, maximizando a funcionalidade em um design
                compacto. Perfeitos para o executivo em viagem rápida ou para a primeira experiência de
                moradia sofisticada.
              </p>
              <p>
                <strong>• Apart Hotels:</strong> Unidades integradas a um complexo hoteleiro, oferecendo a propriedade/uso de
                um flat com todos os serviços de um hotel de luxo (arrumação diária, concierge 24h, etc.).
              </p>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl mb-8" style={{ color: '#D4AF37' }}>Níveis de Acabamento (Padrão Luxo Contemporâneo)</h3>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p>
                <strong>• Design:</strong> Arquitetura minimalista, linhas retas e paleta de cores neutras (cinzas, off-whites, tons
                amadeirados).
              </p>
              <p>
                <strong>• Mobiliário:</strong> Peças de design assinado e marcenaria inteligente que otimiza o espaço.
              </p>
              <p>
                <strong>• Tecnologia:</strong> Automação residencial básica (iluminação/climatização) e conectividade de alta
                velocidade.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Seção 4: Público-Alvo */}
      <section className="bg-black text-white py-24 px-6 md:px-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <img src="/logoEmpe.png" alt="Logo" className="mx-auto w-24 mb-8 opacity-80" />
          </div>
          
          <h2 className="text-3xl md:text-4xl text-center mb-12" style={{ fontFamily: 'serif', color: '#D4AF37' }}>
            Aplicações e Público-Alvo
          </h2>
          
          <div className="mb-16">
            <h3 className="text-2xl mb-8" style={{ color: '#D4AF37' }}>Mercado-Alvo Primário</h3>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p>
                <strong>• Executivos e Nômades Digitais:</strong> Profissionais em transfer temporário ou que requerem bases
                confortáveis em diferentes capitais.
              </p>
              <p>
                <strong>• Investidores Imobiliários:</strong> Proprietários que buscam rentabilidade superior com a gestão
                profissionalizada da rede (modelo pool de locação).
              </p>
              <p>
                <strong>• Viajantes de Lazer Premium:</strong> Hóspedes que desejam a conveniência de um apartamento
                privativo com os serviços de um hotel.
              </p>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl mb-8" style={{ color: '#D4AF37' }}>Diferenciais Competitivos</h3>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p>
                <strong>• Localização Premium:</strong> Imóveis situados nos centros empresariais ou nos bairros mais nobres e
                de fácil acesso das cidades.
              </p>
              <p>
                <strong>• Gestão Full Service:</strong> Administração completa do aluguel, manutenção, e atendimento ao
                hóspede.
              </p>
              <p>
                <strong>• Experiência Consistente:</strong> Padronização do design e dos serviços em toda a rede nacional.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Seção 5: Encerramento */}
      <section className="bg-zinc-900 text-white py-24 px-6 md:px-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-12">
            <img src="/logoEmpe.png" alt="Logo" className="mx-auto w-32 mb-12 opacity-80" />
          </div>
          
          <h2 className="text-3xl md:text-4xl mb-12" style={{ fontFamily: 'serif', color: '#D4AF37' }}>
            Encerramento
          </h2>
          
          <h3 className="text-2xl mb-8" style={{ color: '#D4AF37' }}>O Convite ao Alto Padrão</h3>
          
          <div className="space-y-6 text-gray-300 leading-relaxed mb-12">
            <p>
              A The Pinnacle Flats e Studios convida você a fazer parte de uma rede que não apenas
              hospeda, mas integra o morar contemporâneo com o dinamismo da vida moderna.
            </p>
            <p className="text-xl italic" style={{ color: '#D4AF37' }}>
              "Sua Base. Sua Escolha. Seu Padrão Pinnacle."
            </p>
          </div>
        </div>
      </section>

      {/* Seção 6: Contato */}
      <section className="bg-black text-white py-24 px-6 md:px-20 text-center border-t" style={{ borderColor: '#D4AF37' }}>
        <div className="mb-12">
          <img src="/logoEmpe.png" alt="Logo" className="mx-auto w-32 mb-12" />
        </div>
        
        <h2 className="text-3xl mb-8" style={{ fontFamily: 'serif', color: '#D4AF37' }}>
          Contato Corporativo
        </h2>
        
        <div className="space-y-4 text-lg">
          <p>
            <a href="mailto:diretoria@thepinnacleflats.com.br" className="hover:text-yellow-500 transition-colors" style={{ color: '#D4AF37' }}>
              diretoria@thepinnacleflats.com.br
            </a>
          </p>
          <p className="text-gray-300">
            (91) 99144-5000 | (83) 98221-5000
          </p>
          <p>
            <a 
              href="https://www.thepinnacleflats.com.br" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-yellow-500 transition-colors" 
              style={{ color: '#D4AF37' }}
            >
              www.thepinnacleflats.com.br
            </a>
          </p>
        </div>
        
        <p className="mt-16 text-sm text-gray-500">
          © The Pinnacle Flats e Studios — Desde 2012 • Rede de Flats, Studios e Apart Hotels
        </p>
      </section>
    </div>
  );
}